import { Component, OnInit, OnDestroy, HostBinding, SimpleChanges, SimpleChange, Input, ViewChildren, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConsumerService } from '../../../services/consumer.service';
import swal from 'sweetalert2';
import { LatestBillModel } from '../../../models/consumer/bill.model';
import { CollapsibleDirective } from '../../../directives/collapsible.directive';
import { DataService } from '../../../services/data.service';
import { ConsumerDetailInjector } from '../consumer-detail-injector';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'bill-item',
    templateUrl: './bill-item.component.html',
})



export class BillItemComponent implements OnInit, OnDestroy {

    @ViewChildren(CollapsibleDirective) collapsible;

    public subscriptions: any[] = [];
    public historyBills: any;
    issues: any[] = [];
    latestBill: LatestBillModel[] = [];
    billLoaded: boolean = false;
    historyBillPageSize: number = 5;
    historyBillTotalPages: number = 1;
    billPage: number = 1;
    consumerId: string;
    timePeriod: number = 1;
    clientId: number;
    billItemOpen: boolean = false;
    isSearching: boolean = false;
    totalPages: number = 0;
    page: number = 1;

    constructor(
        private http: HttpClient,
        private consumerService: ConsumerService,
        private route: ActivatedRoute,
        private dataService: DataService,
        private router: Router,
        consumerDetailInjector: ConsumerDetailInjector,
        @Inject('API_BASE_URL') private baseUrl: string) {
        this.issues = consumerDetailInjector.issues;
    }

    onInfoClick() {
        swal({
            title: 'Recent bills',
            html: '<p style="text-align: left;">This widget shows the latest bill value.</p>\
             <p style="text-align: left;">On expansion of the widget, the bill history and breakdown is shown.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }

    ngOnInit() {
        this.clientId = this.route.parent.snapshot.params['clientId'];
        this.subscriptions.push(this.route
            .params
            .subscribe(params => {
                this.consumerId = params['consumerId'];
            }));

        this.subscriptions.push(this.route
            .queryParams
            .subscribe(queryParams => {
                if (+queryParams['timePeriod']) {
                    this.timePeriod = +queryParams['timePeriod'];
                }

                if (+queryParams['billPage']) {
                    this.billPage = +queryParams['billPage'];
                }

                this.getPagedBillHistory(this.billPage);
            }));

        this.consumerService.getLatestBill(this.clientId, this.consumerId).then((latestBillRes) => {
            this.latestBill = latestBillRes;
            this.billLoaded = true;

        });

        this.consumerService.getHistoryBill(this.clientId, this.consumerId, this.billPage).then((historyBillRes) => {
            if (historyBillRes && historyBillRes.historyBills.length > 0) {
                this.dataService.billItemComponentResolved.next(true);
                this.historyBills = historyBillRes.historyBills as any;
                for (let i = 0; i < this.historyBills.length; i++) {
                    this.historyBills[i].billTypeString = "";
                    this.historyBills[i].isCollapsed = true;
                    if (this.historyBills[i].billType == 0) { this.historyBills[i].billTypeString = "Actual"; }
                    if (this.historyBills[i].billType == 1) { this.historyBills[i].billTypeString = "Estimated"; }
                    if (this.historyBills[i].billType == 2) { this.historyBills[i].billTypeString = "Independent"; }
                    if (this.historyBills[i].billType == 3) { this.historyBills[i].billTypeString = "Credit Bill"; }
                }

                this.totalPages = historyBillRes.totalPages;

            } else { this.latestBill = null; this.dataService.billItemComponentResolved.next(false); }
        });

    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    billpageSelected(page: number) {
        this.billPage = page;
        this.getPagedBillHistory(page);
    }

    toggleBillItemExpand(index: number) {
        this.dataService.updateMasonry.next(true);
        for (let i = 0; i < this.historyBills.length; i++) {
            if (i != index) {
                if (this.collapsible && this.collapsible._results[i].isCollapsed === false) {
                    this.collapsible._results[i].isCollapsed = true;
                    this.collapsible.first.collapseItemSection(this.collapsible._results[i].collapsibleSection);
                }

                this.historyBills[i].isCollapsed = true;

            } else { this.historyBills[i].isCollapsed = !this.historyBills[i].isCollapsed; }
        }
    }

    getBillsDocument(invoiceNo: string) {
        
        this.consumerService.getBillDocument(this.clientId, this.consumerId, invoiceNo).then((res) => {

            let blob = this.base64ToBlob(res);            
            var blobUrl = URL.createObjectURL(blob);
            var link = document.createElement("a"); // Or maybe get it from the current document
            link.href = blobUrl;
            link.download = invoiceNo + '.pdf';                
            link.click();            
        });
    }

    base64ToBlob(data: string): Blob {
        var byteCharacters = atob(data);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: 'application/pdf' });
    };

    getPagedBillHistory(page: number) {

        let queryParams: any = JSON.parse(JSON.stringify(this.route.snapshot.queryParams)) as any;
        queryParams.billPage = page;

        this.consumerService.getHistoryBill(this.clientId, this.consumerId, this.billPage).then((historyBillRes) => {
            if (historyBillRes && historyBillRes.historyBills.length > 0) {
                this.historyBills = historyBillRes.historyBills as any;
                this.dataService.billItemComponentResolved.next(true);
                for (let i = 0; i < this.historyBills.length; i++) {
                    this.historyBills[i].billTypeString = "";
                    this.historyBills[i].isCollapsed = true;
                    if (this.historyBills[i].billType == 0) { this.historyBills[i].billTypeString = "Actual"; }
                    if (this.historyBills[i].billType == 1) { this.historyBills[i].billTypeString = "Estimated"; }
                    if (this.historyBills[i].billType == 2) { this.historyBills[i].billTypeString = "Independent"; }
                    if (this.historyBills[i].billType == 3) { this.historyBills[i].billTypeString = "Credit Bill"; }
                }

                this.totalPages = historyBillRes.totalPages;

            } else { this.latestBill = null; this.dataService.billItemComponentResolved.next(false); }
        });

    }
}
